import React, { ReactNode } from 'react';
import { useUserProfile } from '../hooks/useUserProfile';
import { UserScope } from '../types/auth.types';

interface ScopeGuardProps {
  children: ReactNode;
  requiredScopes: UserScope[];
  requireAll?: boolean;
  fallback?: ReactNode;
}

export const ScopeGuard: React.FC<ScopeGuardProps> = ({
  children,
  requiredScopes,
  requireAll = false,
  fallback = null,
}) => {
  const { hasAnyEffectiveAccess, hasAllEffectiveAccess, isLoading } = useUserProfile();

  if (isLoading) {
    return null;
  }

  const hasAccess = requireAll
    ? hasAllEffectiveAccess(requiredScopes)
    : hasAnyEffectiveAccess(requiredScopes);

  if (!hasAccess) {
    return <>{fallback}</>;
  }

  return <>{children}</>;
};

interface SingleScopeGuardProps {
  children: ReactNode;
  scope: UserScope;
  fallback?: ReactNode;
}

export const SingleScopeGuard: React.FC<SingleScopeGuardProps> = ({
  children,
  scope,
  fallback = null,
}) => {
  const { hasEffectiveAccess, isLoading } = useUserProfile();

  if (isLoading) {
    return null;
  }

  if (!hasEffectiveAccess(scope)) {
    return <>{fallback}</>;
  }

  return <>{children}</>;
};
